<template>
  <svg viewBox="0 0 36 36">
    <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke-width="0.24em" stroke-dasharray="100, 100" stroke="rgba(var(--color-foreground), 0.05)"/>
    <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke-width="0.2em" stroke-linecap="round" :stroke-dasharray="dashArray" :class="'stroke-' + color" style="animation: gauge-view-style-progress-animation 1s ease-out forwards;"/>
  </svg>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  max: Number,
  value: Number,
  color: String
});

const percentage = computed(() => Math.round(props.value / props.max * 100));

const dashArray = computed(() => percentage.value + ", 100");

</script>

<style>
@keyframes gauge-view-style-progress-animation {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>